// Search aliases affect matching only; stored category IDs and business text stay unchanged.
const groups = [
 ['belleza','beleza'], ['barberia','barberias','barbearia','barbearias'],
 ['unas','unhas'], ['masaje','masajes','massagem','massagens'],
 ['bienestar','bemestar'], ['cabello','cabelo'], ['maquillaje','maquiagem'],
 ['pestanas','cilios'], ['cejas','sobrancelhas'], ['depilacion','depilacao'],
 ['fotografia','fotografias'], ['entretenimiento','entretenimento'],
 ['servicio','servicios','servico','servicos'], ['otros','outros'],
 ['manicure','manicura'], ['pedicure','pedicura']
];
const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/bem[\s_-]+estar/g,'bemestar').replace(/[^a-z0-9]+/g,' ').trim();
const equivalents = new Map(groups.flatMap(group=>group.map(word=>[word,group])));
export function matchesLocalizedSearch(text, query) {
 const haystack=normalize(text),needle=normalize(query);
 if(!needle || !haystack)return false;
 if(haystack.includes(needle))return true;
 const tokens=needle.split(' ').filter(token=>token.length>1);
 return tokens.length>0 && tokens.every(token=>(equivalents.get(token)||[token]).some(word=>haystack.includes(word)));
}
